{
    "name": "hgm-charts",
    "version": "0.2.3",
    "author": "HGM Automotive Electronics",
    "homepage": "http://hgmelectronics.com/",
    "description": "HGM data charting and analysis tool",
    "private": true,
    "license": "UNLICENSED",
    "repository": {
        "type": "git",
        "url": "ssh://git@bitbucket.org/hgmelectronics/hgm-charts.git"
    },
    "engines": {
        "node": "^24.11",
        "npm": "^11.6"
    },
    "scripts": {
        "ng": "ng",
        "start": "node update-git-versions.js && ng serve",
        "prebuild": "node update-git-versions.js",
        "build": "ng build",
        "test": "jest",
        "lint-staged-check": "lint-staged --config src/hgm-setup/etc/lint-staged-check.json --quiet",
        "lint-staged-write": "lint-staged --config src/hgm-setup/etc/lint-staged-write.json",
        "lint-check": "node src/hgm-setup/etc/lint-all.js src/hgm-setup/etc/lint-staged-check.json",
        "lint-write": "node src/hgm-setup/etc/lint-all.js src/hgm-setup/etc/lint-staged-write.json",
        "lint-check-hgm-setup": "node src/hgm-setup/etc/lint-all.js -C src/hgm-setup src/hgm-setup/etc/lint-staged-check.json",
        "lint-write-hgm-setup": "node src/hgm-setup/etc/lint-all.js -C src/hgm-setup src/hgm-setup/etc/lint-staged-write.json",
        "prettify": "prettier --write . --ignore-path .gitignore",
        "reinstall": "rm -rf node_modules package-lock.json && npm install"
    },
    "dependencies": {
        "@angular/animations": "~19.2.18",
        "@angular/common": "~19.2.18",
        "@angular/core": "~19.2.18",
        "@angular/forms": "~19.2.18",
        "@angular/platform-browser": "~19.2.18",
        "@angular/platform-browser-dynamic": "~19.2.18",
        "@angular/router": "~19.2.18",
        "@angular/service-worker": "~19.2.18",
        "@capacitor/device": "^8.0.2",
        "@capacitor/keyboard": "^8.0.5",
        "@ionic/angular": "^8.8.12",
        "angular-resizable-element": "github:hgmelectronics/angular-resizable-element#dist",
        "browser-util-inspect": "^0.2.0",
        "chart.js": "^4.5.1",
        "expr-eval": "^2.0.2",
        "fuse.js": "^7.4.2",
        "lodash-es": "^4.18.1",
        "md5": "^2.3.0",
        "pako": "^2.2.0",
        "pino": "10.3.1",
        "rxjs": "^7.8.2",
        "tmp": "^0.2.7",
        "tslib": "^2.8.1",
        "zone.js": "^0.15.1"
    },
    "devDependencies": {
        "@angular-devkit/build-angular": "~19.2.19",
        "@angular-eslint/builder": "^18.2.0",
        "@angular-eslint/eslint-plugin": "^18.2.0",
        "@angular-eslint/eslint-plugin-template": "^18.0.1",
        "@angular-eslint/schematics": "^18.0.1",
        "@angular-eslint/template-parser": "^18.0.1",
        "@angular/cli": "~19.2.19",
        "@angular/compiler": "~19.2.18",
        "@angular/compiler-cli": "~19.2.18",
        "@angular/language-service": "~19.2.18",
        "@aparajita/capacitor-dark-mode": "^6.0.0",
        "@capacitor/core": "^8.4.1",
        "@capacitor/filesystem": "^8.1.2",
        "@capacitor/preferences": "^8.0.1",
        "@capacitor/screen-orientation": "^8.0.1",
        "@capacitor/status-bar": "^8.0.2",
        "@ionic/angular-toolkit": "^12.3.0",
        "@maskito/core": "^5.3.1",
        "@types/jest": "30.0.0",
        "@types/json-logic-js": "^2.0.8",
        "@types/lodash": "^4.17.24",
        "@types/lodash-es": "^4.17.12",
        "@types/md5": "^2.3.6",
        "@types/node": "25.9.1",
        "@types/pako": "^2.0.4",
        "@types/proper-lockfile": "^4.1.4",
        "@types/systeminformation": "^3.54.1",
        "@types/tmp": "^0.2.6",
        "@typescript-eslint/eslint-plugin": "8.62.0",
        "@typescript-eslint/parser": "8.62.0",
        "commander": "^15.0.0",
        "electron": "42.5.0",
        "eslint": "^9.39.2",
        "eslint-config-prettier": "^10.1.8",
        "eslint-import-resolver-typescript": "^4.4.5",
        "eslint-plugin-import": "^2.32.0",
        "eslint-plugin-prefer-arrow": "1.2.3",
        "execa": "^9.6.1",
        "jest": "^29.7.0",
        "jest-preset-angular": "^14.6.2",
        "json-logic-js": "github:hgmelectronics/json-logic-js#master",
        "lint-staged": "^16.3.2",
        "lodash": "^4.18.1",
        "minimatch": "^10.2.5",
        "prettier": "^3.9.1",
        "simple-git": "^3.36.0",
        "text-encoding-shim": "^1.0.5",
        "ts-jest": "^29.4.11",
        "ts-node": "^10.9.2",
        "typescript": "~5.8.3"
    }
}
